import { render } from "./PopupInfoBlockUser.vue?vue&type=template&id=3b7d7ac6"
import script from "./PopupInfoBlockUser.vue?vue&type=script&lang=js"
export * from "./PopupInfoBlockUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__